'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../tslib.es6-130a177d.js');
var React = require('react');
var colors = require('../../../colors-b14f6805.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SvgClubClock = function (props) {
    var className = props.className, _a = props.expiryState, expiryState = _a === void 0 ? 'default' : _a;
    var svgProps = tslib_es6.__assign(tslib_es6.__assign({}, props), { className: '', theme: undefined });
    var fillColor = expiryState === 'default' ? colors.colors.yellow50 : colors.colors.red50;
    return (React__default['default'].createElement("div", { className: className },
        React__default['default'].createElement("svg", tslib_es6.__assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", width: "20", height: "20" }, svgProps),
            React__default['default'].createElement("circle", { cx: "50", cy: "50", r: "40", stroke: "#323232", strokeWidth: "4", fill: fillColor }),
            React__default['default'].createElement("line", { x1: "50", y1: "52", x2: "50", y2: "20", stroke: "#323232", strokeWidth: "4" }),
            React__default['default'].createElement("line", { x1: "50", y1: "50", x2: "70", y2: "50", stroke: "#323232", strokeWidth: "4" }))));
};

exports.default = SvgClubClock;
//# sourceMappingURL=index.js.map
